export default "__VITE_ASSET__B7HNa6$q__"